module.exports = __webpack_public_path__ + "static/media/Business.c987f465.png";